module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-backplates-remnants.746488bd.png";